<template>
  <div id="box1">
    <div class="box" :style="{ backgroundImage: `url(${bg})` }">
      <div class="one">SVIP在线就业班新课上线</div>
      <div class="two">现在报名最高优惠2000元，越早报名优惠越多</div>
    </div>
    <div class="connect"></div>
    <div class="box2">
      <div class="box2-title">什么是SVIP在线就业班？</div>
      <div class="box2-one">
        <div class="box2-one-title">课程简介</div>
        <div class="box2-one-txt">
          针对有明确就业及薪资要求的用户，推出的全套就业保障课程。
        </div>
      </div>
      <div class="box2-two">
        <div class="box2-two-title">核心亮点</div>
        <div class="box2-two-txt">原汁原味的黑马课程体系</div>
        <div class="box2-two-txt">私人订制的高效学习路径</div>
        <div class="box2-two-txt">高质量完整的阶段评测</div>
        <div class="box2-two-txt">完善的就业服务、薪资保障</div>
      </div>
      <div class="button" @click="Open($event)">立抢优惠</div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    Open(e) {
      this.$store.commit("Openpop", 1);
      this.$mai(2,e)
    },
  },
  data() {
    return {
      fistlive: () => {
        if (
          new Date() > new Date("2021/5/10 00:00:00") &&
          new Date() < new Date("2021/5/16 23:59:59")
        ) {
          return true;
        } else {
          return false;
        }
      }, // 第一阶段
      secondlive: () => {
        if (
          new Date() > new Date("2021/5/17 00:00:00") &&
          new Date() < new Date("2021/5/23 23:59:59")
        ) {
          return true;
        } else {
          return false;
        }
      }, //第二阶段
      thirdlive: () => {
        if (
          new Date() > new Date("2021/5/24 00:00:00") &&
          new Date() < new Date("2021/5/31 23:59:59")
        ) {
          return true;
        } else {
          return false;
        }
      }, //第三阶段
      bg:""
    };
  },
  mounted(){
    if(this.fistlive()){
      this.bg = require('../assets/live1.png')
    }else if(this.secondlive()){
      this.bg = require('../assets/live2.png')
    }else if(this.thirdlive()){
      this.bg = require('../assets/live3.png')
    }
  }
};
</script>

<style lang='scss' scoped>
.box {
  overflow: hidden;
  margin: 0 auto;
  width: 690px;
  height: 1018px;
  background-color: #6b00d9;
  // background-image: url("../assets/timeline.png");
  background-size: 614px 786px;
  background-repeat: no-repeat;
  background-position: center 160px;
  .one {
    font-family: SourceHanSansCN-Regular;
    font-size: 26px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 1px;
    color: #ffffff;
    text-align: center;
    margin-top: 49px;
  }
  .two {
    @extend .one;
    margin-top: 15px;
  }
}
.box2 {
  overflow: hidden;
  margin: 0 auto;
  margin-bottom: 80px;
  width: 690px;
  height: 744px;
  background-color: #6b00d9;
  &-title {
    margin: 0 auto;
    margin-top: 30px;
    width: 476px;
    height: 72px;
    background-color: #45008b;
    border-radius: 10px;
    font-family: SourceHanSansCN-Bold;
    font-size: 32px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 72px;
    letter-spacing: 2px;
    color: #ffffff;
    text-align: center;
  }
  &-one {
    overflow: hidden;
    margin: 0 auto;
    margin-top: 30px;
    width: 650px;
    height: 164px;
    background-color: #9f7fff;
    border-radius: 10px 10px 0 0;
    &-title {
      margin-top: 31px;
      padding-left: 41px;
      font-family: SourceHanSansCN-Bold;
      font-size: 30px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 3px;
      color: #fcec4e;
    }
    &-txt {
      width: 551px;
      margin-top: 10px;
      padding-left: 58px;
      font-family: SourceHanSansCN-Normal;
      font-size: 24px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 2px;
      color: #ffffff;
      &::before {
        content: "";
        display: inline-block;
        width: 8px;
        height: 8px;
        background-color: #ffffff;
        margin-left: -20px;
        position: relative;
        top: -5px;
      }
    }
  }

  &-two {
    overflow: hidden;
    margin: 0 auto;
    width: 650px;
    height: 280px;
    background-image: url('../assets/bgggg.png');
    background-size: cover;
    border-radius: 0 0 10px 10px;
    &-title {
      margin-top: 31px;
      padding-left: 41px;
      font-family: SourceHanSansCN-Bold;
      font-size: 30px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 3px;
      color: #f94b4d;
    }
    &-txt {
      width: 551px;
      margin-top: 10px;
      font-family: SourceHanSansCN-Normal;
      font-size: 24px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 2px;
      color: #2d2664;
      &::before {
        content: "";
        display: inline-block;
        width: 8px;
        height: 8px;
        background-color: #2d2664;
        margin-left: 38px;
        margin-right: 10px;
        position: relative;
        top: -5px;
      }
    }
  }
  .button {
    margin: 0 auto;
    margin-top: 40px;
    text-align: center;
    width: 560px;
    height: 88px;
    border-radius: 16px;
    background-image: url("../assets/btn.png");
    background-size: cover;

    font-family: SourceHanSansCN-Bold;
    font-size: 36px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 88px;
    letter-spacing: 2px;
    color: #5530fd;
  }
}
</style>